export const $default = [
    {
        url: "/users/profile",
        title: "Profile",
        icon: "si si-user"
    },
    // Disabled until when feature is complete
    {
        url: "/accounts/billing",
        title: "Billing",
        icon: "si si-credit-card",
        env: ["development", "staging", "production"]
    },
    {
        url: "/apis",
        title: "APIs and Services",
        icon: "si si-rocket",
        roles: ["admin"]
    },

    {
        title: "Shortcodes",
        icon: "si si-call-out",
        children: [
            {
                url: "/services/my-short-codes",
                title: "My Short Codes",
                roles: ["developer", "reseller"]
            },
            {
                url: "/services/short-codes",
                title: "All Short Codes",
                roles: ["admin"]
            },
            {
                url: "/services/short-codes/create",
                title: "On-Board Short Codes",
                roles: ["admin"]
            }
        ]
    }
];

export const $projectPaths = function (route) {
    let project = route.params.project;
    let dashboard = [
        {
            url: "/dashboard",
            title: "Projects",
            icon: "si si-grid"
        },
    ];
    if (typeof project !== "undefined") {
        let projectPaths = [
            {
                url: `/projects/${project}/overview`,
                title: "Dashboard",
                icon: "si si-home"
            },
            {
                path: `/projects/${project}/sms`,
                title: "SMS",
                icon: "si si-envelope",
                allowedApis: ["bulk-sms"],
                children: [
                    {
                        url: `/projects/${project}/sms/express/send`,
                        title: "Send Express Message"
                    },
                    {
                        url: `/projects/${project}/sms/bulk/send`,
                        title: "Send Bulk Message"
                    },
                    {
                        url: `/projects/${project}/sms/custom/upload-file`,
                        title: "Custom Bulk Message"
                    },
                    {
                        url: `/projects/${project}/sms/subscription/send`,
                        title: "Send Subscription Message",
                        allowedApis: ["subscription-messaging"],
                    },
                    {
                        url: `/projects/${project}/sms/bulk-outbox`,
                        title: "Bulk SMS Outbox"
                    },
                    {
                        url: `/projects/${project}/sms/api-outbox`,
                        title: "API Outbox"
                    },
                    {
                        url: `/projects/${project}/sms/inbox`,
                        title: "Inbound Messages"
                    },
                    {
                        url: `/projects/${project}/sms/premium-outbox`,
                        title: "Premium SMS Outbox",
                        allowedApis: ["subscription-messaging"],
                    },
                    {
                        url: `/projects/${project}/sms/short-codes`,
                        title: "Short Codes"
                    },
                    {
                        url: `/projects/${project}/sms/reports/exports`,
                        title: 'Exported Searches'
                    }
                ]
            },
            {
                path: `/projects/${project}/airtime`,
                title: "Airtime",
                icon: "si si-screen-tablet",
                allowedApis: ["airtime"],
                children: [
                    {
                        url: `/projects/${project}/airtime/transactions`,
                        title: "Transactions"
                    }
                ]
            },
            {
                path: `/projects/${project}/utility-bills`,
                title: "Utility Bills",
                icon: "si si-wallet",
                allowedApis: ["utility-bills"],
                children: [
                    {
                        url: `/projects/${project}/utility-bills/transactions`,
                        title: "Transactions"
                    }
                ]
            },
            {
                path: `/projects/${project}/pg`,
                title: "Payment Gateway",
                icon: "si si-wallet",
                allowedApis: ["payment-gateway"],
                children: [
                    {
                        url: `/projects/${project}/pg/transactions`,
                        title: "Transactions"
                    },
                    {
                        url: `/projects/${project}/pg/settings/keys`,
                        title: "Public Keys"
                    },
                    {
                        url: `/projects/${project}/pg/settings/mpesa`,
                        title: "M-PESA Settings"
                    },
                    {
                        url: `/projects/${project}/pg/settings/callback`,
                        title: "Callback Settings"
                    }
                ]
            },
            {
                path: `/projects/${project}/senti`,
                title: "Senti",
                icon: "si si-screen-tablet",
                allowedApis: ["senti-micro-lending"],
                children: [
                    {
                        url: `/projects/${project}/senti/salary_advance/dashboard`,
                        title: "Dashboard"
                    },
                    {
                        url: `/projects/${project}/senti/salary_advance/get_requests`,
                        title: "My Requests"
                    },
                    {
                        url: `/projects/${project}/senti/salary_advance/get_employees`,
                        title: "My Employees"
                    },
                    {
                        url: `/projects/${project}/senti/salary_advance/register_employee`,
                        title: "Add Employee"
                    }
                ]
            },

            {
                path: `/projects/${project}/chats`,
                title: "Chats",
                icon: "si si-speech",
                allowedApis: ["chat"],
                children: [
                    {
                        url: `/projects/${project}/chats/webchat`,
                        title: "Web Chats"
                    }
                ]
            },
            {
                path: `/projects/${project}/settings`,
                title: "Settings",
                icon: "si si-settings",
                children: [
                    {
                        url: `/projects/${project}/settings/apps`,
                        title: "API Services"
                    }
                ]
            },
        ]

        return {
            items: [...projectPaths, ...$default]
        }
    }
    return {
        items: [...dashboard, ...$default]
    }
}

//6015142000139912;29066
